import _ from 'lodash';
import moment from 'moment';
import templateStr from 'text!./cancel-policy.html';
import 'portalConfig';
import LocalDateUtil from 'gw-portals-util-js/LocalDateUtil';

export default () => {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            policy: '=',
            hideForm: '&'
        },
        controller: ['$scope', 'PolicyService', 'UserService', 'CancellationService', '$window', '$q', 'ModalService', 'ViewModelService', '$state', '$filter', ($scope, PolicyService, UserService, CancellationService, $window, $q, ModalService, ViewModelService, $state, $filter) => {
            // Create source Typelist - either insured or CancellationSource Typelist
            // Get Cancellation Source anytime the Source type list is changed.
            // Get Refund code if other 2 are ok based on PeriodStart Date
            //

            $scope.cancellation = {
                'cancellationSource': '',
                'cancelReasonCode': '',
                'description': '',
                'cancellationRefundMethod': '',
                'effectiveDate': '',
                'mileage': '',
                'currentMileage': '',
                cancellationRequestDate: LocalDateUtil.today(),
            };

            $scope.effectiveDateValidation = {
                'isValid': false,
                'validationErrorMessage': ''
            };
            $scope.mileageValidation = {
                'isValid': false,
                'validationErrorMessage': ''
            };
            $scope.descriptionValidation = {
                'isValid': false,
                'validationErrorMessage': ''
            };
            $scope.currentMileage = 0;
            $scope.cancellationView = ViewModelService.create($scope.cancellation, 'pc', 'edge.capabilities.gateway.job.cancellation.dto.CancellationDTO');
            $scope.cancellationView.cancellationSource = _.find($scope.cancellationView.cancellationSource.aspects.availableValues, {
                code: 'insured'
            });

            $scope.acccessingXCenter = false;
            $scope.reasonCodes = _.filter($scope.cancellationView.cancelReasonCode.aspects.availableValues, function (reason) { return reason.code == 'Satisfied_PSA' });
            $scope.refundMethods = []; // PSA $scope.cancellationView.cancellationRefundMethod.aspects.availableValues;

            const today = LocalDateUtil.today();
            $scope.today = new Date(Date.UTC(today.year, today.month, today.day, 0, 0, 0, 0));

            $scope.earliestCancellationDate = new Date($scope.policy.latestPeriod.effectiveDate);
            $scope.earliestCancellationDate.setDate($scope.earliestCancellationDate.getDate() + 1);
            $scope.earliestCancellationDate.setHours(0, 0, 0, 0);

            function reasonChanged() {
                if ($scope.cancellation.cancelReasonCode !== '') {
                    $scope.cancellation.cancellationRefundMethod = '';
                    $scope.cancellation.effectiveDate = '';

                    getRefundMethods();
                }
            }
            //UCWAR-201 GVO Policy Cancellation
            function descriptionChanged() {
                if ($scope.cancellation.description !== '') {
                    $scope.descriptionValidation.isValid = true;
                } else {
                    $scope.descriptionValidation.isValid = false;
                }
            }
            function mileageChanged() {
                if ($scope.cancellation.mileage !== '' && $scope.cancellation.mileage !== null) {
                    $scope.getCurrentMileage();
                    if ($scope.cancellation.mileage < $scope.currentMileage) {
                        $scope.mileageValidation.isValid = false;
                        $scope.mileageValidation.validationErrorMessage = $filter('translate')('gateway.directives.cancel-policy.Mileage at Cancellation') + $scope.currentMileage;
                    } else if ($scope.cancellation.mileage - $scope.currentMileage > 1500) {
                        $scope.mileageValidation.isValid = false;
                        $scope.mileageValidation.validationErrorMessage = $filter('translate')('gateway.directives.cancel-policy.More than 1500 km has done');
                    } else {
                        $scope.mileageValidation.isValid = true;
                        $scope.mileageValidation.validationErrorMessage = '';
                    }
                } else {
                    $scope.mileageValidation.isValid = false;
                    $scope.mileageValidation.validationErrorMessage = '';
                }
            }

            function getRefundMethods() {
                const tempCancellation = {
                    'cancellationSource': $scope.cancellation.cancellationSource,
                    'cancelReasonCode': $scope.cancellation.cancelReasonCode,
                    'isTempCancellation': true
                };
                const refundMethodPromise = CancellationService.getRefundMethods($scope.policy.policyNumber, tempCancellation);

                refundMethodPromise.then((methods) => {
                    $scope.refundMethods = _.filter($scope.cancellationView.cancellationRefundMethod.aspects.availableValues, (x) => {
                        return methods.indexOf(x.code) !== -1;
                    });
                    if ($scope.refundMethods.length === 1) {
                        //set default Refundmethod if only 1 available
                        $scope.cancellationView.cancellationRefundMethod.value = $scope.refundMethods[0];
                    }
                });
            }

            function refundMethodChanged() {
                if ($scope.cancellation.cancellationRefundMethod !== '') {
                    $scope.cancellation.effectiveDate = '';
                    getEffectiveDateForCancellation();
                }
            }

            function getEffectiveDateForCancellation() {
                const tempCancellation = {
                    'cancellationSource': $scope.cancellation.cancellationSource,
                    'cancelReasonCode': $scope.cancellation.cancelReasonCode,
                    'cancellationRefundMethod': $scope.cancellation.cancellationRefundMethod,
                    'isTempCancellation': true
                };
                const effectiveDatePromise = CancellationService.getEffectiveDateForCancellation($scope.policy.policyNumber, tempCancellation);

                effectiveDatePromise.then((effectiveDate) => {
                    $scope.cancellation.effectiveDate = effectiveDate;
                });
            }


            $scope.startCancellation = (form) => {
                form.submitted = true;
                $scope.validateEffectiveDate();
                if (!form.invalid && $scope.effectiveDateValidation.isValid && $scope.mileageValidation.isValid && $scope.descriptionValidation.isValid) {
                    $scope.cancellationPromise = PolicyService.createNewPolicyCancellationTransaction($scope.policy.policyNumber, $scope.cancellation);

                    $q.when(
                        $scope.cancellationPromise,
                        (job) => {
                            $state.transitionTo('cancellation.detail.summary', { cancellationNumber: job.jobNumber });
                        },
                        (error) => {
                            ModalService.showError('Error', $q.when(error.baseError.data.error.message));
                        }
                    );
                }
            };
            $scope.getCurrentMileage = () => {
                //UCWAR-201 GVO Policy Cancellation
                if (Object.keys($scope.policy.lobs.puw_PSA).length != 0) {
                    $scope.policy.lobs.puw_PSA.vehicleDTOs.forEach(coverable => {
                        if (coverable.coverages.length > 0) {
                            $scope.currentMileage = coverable.currentMileage;
                        }
                    });
                }
                if (Object.keys($scope.policy.lobs.egvn_psa).length != 0) {
                    $scope.policy.lobs.egvn_psa.vehicleDTOs.forEach(coverable => {
                        if (coverable.coverages.length > 0) {
                            $scope.currentMileage = coverable.currentMileage;
                        }
                    });
                }
            }
            $scope.validateEffectiveDate = () => {
                const latestPeriodExpiryDate = moment($scope.policy.latestPeriod.expirationDate);
                const latestPeriodEffectiveDate = moment($scope.policy.latestPeriod.effectiveDate);
                const chosenEffectiveDate = moment($scope.cancellation.effectiveDate);
                if (chosenEffectiveDate.isBefore(latestPeriodEffectiveDate)) {
                    $scope.effectiveDateValidation.isValid = false;
                    $scope.effectiveDateValidation.validationErrorMessage = $filter('translate')('gateway.directives.cancel-policy.Please set a date that is after the start date of the policy');
                    return;
                }
                if (chosenEffectiveDate.isAfter(latestPeriodExpiryDate)) {
                    $scope.effectiveDateValidation.isValid = false;
                    $scope.effectiveDateValidation.validationErrorMessage = $filter('translate')('gateway.directives.cancel-policy.Please set a date that is before the expiry date of the policy');
                    return;
                }
                $scope.effectiveDateValidation.isValid = true;
                $scope.effectiveDateValidation.validationErrorMessage = '';
            };

            $scope.$watch('cancellation.cancelReasonCode', () => {
                reasonChanged();
            });
            $scope.$watch('cancellation.cancellationRefundMethod', () => {
                refundMethodChanged();
            });

            $scope.$watch('cancellation.effectiveDate', () => {
                if ($scope.cancellation.effectiveDate) {
                    $scope.validateEffectiveDate();
                }
            });

            $scope.$watch('cancellation.description', () => {
                descriptionChanged();
            });
            $scope.$watch('cancellation.mileage', () => {
                mileageChanged();
            });
        }]
    };
};
